// Страница /promo-codes — промокоды (раньше жили на /marketing).
import React from "react";
import { Layout } from "../../components/Layout/Layout";
import PromoCodesTable from "../../components/PromoCodesTable";
import "../sales/index.css";

const PromoCodes: React.FC = () => {
  return (
    <Layout>
      <div className="sales-head">
        <h2 style={{ fontSize: 18, fontWeight: 500 }}>Промокоды</h2>
      </div>
      <PromoCodesTable />
    </Layout>
  );
};

export default PromoCodes;
